import { createFileRoute } from "@tanstack/react-router";

import { ProductStarlinkDetail } from "./-components/ProductStarlinkDetail";

export const Route = createFileRoute(
  "/_staff/marketplace/_store/store/starlinks/$productId/",
)({
  component: ProductStarlinkDetail,
});
